import { render, staticRenderFns } from "./UserTweets.vue?vue&type=template&id=64e8cd6a&scoped=true&"
import script from "./UserTweets.vue?vue&type=script&lang=js&"
export * from "./UserTweets.vue?vue&type=script&lang=js&"
import style0 from "./UserTweets.vue?vue&type=style&index=0&id=64e8cd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e8cd6a",
  null
  
)

export default component.exports